module.exports = __webpack_public_path__ + "img/2014-05-22.9734f6fe.jpg";